import Category from 'features/pricing/components/category';
import type React from 'react';
import type { ReactElement } from 'react';
import type { ServicePricing } from 'types/services';

interface Props {
  readonly pricing: ServicePricing;
}

export default function Pricing({ pricing }: Props): ReactElement {
  return (
    <div>
      {pricing.map(category => (
        <Category
          category={category}
          key={category._key ?? category.categoryLabel}
        />
      ))}
    </div>
  );
}
